import callHookListeners from './call-hook-listeners';
import availableHooks from '../constants/available-hooks';
import extensionHooks from '../constants/extension-hooks';
import getLogger from '../../logger/accessors/get-logger';

const availableHookNames = Object.values(availableHooks);
const extensionHookNames = Object.values(extensionHooks);

const trigger = (hookName, ...args) => {
  if (availableHookNames.includes(hookName) || extensionHookNames.includes(hookName)) {
    getLogger().error(`"${hookName}" is internal hook, and it can't be executed out of the sdk`);
    return;
  }

  callHookListeners(hookName, ...args);
};

export default trigger;
